import { Component, Fragment, createRef } from 'preact';

import { Input, PositioningMode } from '@szn/suggestlist';
import classnames from 'classnames';

import ViewContext from '../../../view/ViewContext';
import Button from '../../button/Button';
import Icon from '../../icon/Icon';

export default class DesktopSearch extends Component {
	static get contextType() {
		return ViewContext;
	}

	constructor() {
		super();

		this._suggestListContainerRef = createRef();
		this._inputRef = createRef();

		this._suggestListRenderer = this._suggestListRenderer.bind(this);

		this.state = {
			suggestList: null
		};
	}

	render() {
		const { suggestList } = this.state;

		return (
			<Fragment>
				<div className='ribbon-search-desktop'>
					<Input
						ariaLabel='Vyhledat'
						ref={this._inputRef}
						name={this.props.searchQueryParameter}
						inputDataDot='lista_hledani_kurzor'
						searchPhrase={this.props.searchPhrase}
						suggestListItems={this.props.suggestListItems}
						positioningMode={PositioningMode.STATIC}
						size={5}
						suggestListRenderer={this._suggestListRenderer}
						dataDot='lista_hledani_fulltext'
						placeholder='Hledat...'
						onChange={this.props.onChange}
						onClick={this.props.onClick}
						onRemoveFromHistory={this.props.onRemoveFromHistory}
						onSubmit={this.props.onSubmit}
					/>
					<Button
						className={classnames({
							'ribbon-search-desktop__clear': true,
							'ribbon-search-desktop__clear--visible': this.props.searchPhrase
						})}
						onClick={this.props.onClear}
						data-dot='lista_hledani_krizek'
					>
						<Icon icon='cross' className='ribbon-search-desktop__icon-cross' />
					</Button>
					<div
						className='ribbon-search-desktop__suggest'
						ref={this._suggestListContainerRef}
					>
						{suggestList}
					</div>
				</div>
				<Button
					className='ribbon-search-desktop__submit'
					type='submit'
					aria-label='Vyhledat'
					data-dot='lista_hledani_button'
					data-e2e='ribbon-search-button'
				>
					<Icon icon='search' className='ribbon-search-desktop__icon-search' />
				</Button>
			</Fragment>
		);
	}

	focus() {
		this._inputRef.current && this._inputRef.current.focus();
	}

	_suggestListRenderer(suggestList) {
		this.setState({
			suggestList
		});

		return this._suggestListContainerRef.current;
	}
}
